import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * @description TabPanel component for switching between card and ACH payment methods
 */
const TabPanel = ({ children, value, index, hidden = false }) => {
  if (hidden) return null;
  return (
    <Box role="tabpanel" hidden={value !== index}>
      {value === index && children}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  hidden: PropTypes.bool,
};

export default TabPanel;
